﻿import {translation} from "@2d-front-monorepo/core";
import {PermitResult, Permits, PermitStatusType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {Link} from "react-router";
import {formatRoute, PrivateRoutes} from "../../../routes";

export function RenewComponent({permit}: { permit: PermitResult }): JSX.Element | undefined {
	const renewEnabled = permit.status.type === PermitStatusType.AboutToExpire && !Permits.alreadyRenewed(permit);
	if (!renewEnabled) {
		return undefined;
	}

	return (
		<div className={"padded inline"}>
			<p className={"layout horizontal aligned middle form-message form-message--warning"}>
				<span className={"flex"}>{translation(PermitTranslations.permit_page__renew__title)}</span>
				<Link className="form__button form__button--primary form__button--small"
				      to={formatRoute(PrivateRoutes.permitsRenew, permit.id)}>
					{translation(PermitTranslations.permit_page__renew__button)}
				</Link>
			</p>
		</div>
	);
}
